import { IconBookmark, IconDownload, IconInfo, IconKey, IconPhone, IconPlug, IconPower, IconShare, IconThumbUp, IconUser } from '@assets/images/icon';
import { IconCard, IconTopology } from '@assets/images/main';
import { accessAutoMain, accessLite1, accessProSchemeThumb } from '@assets/images/main/access/product';

export default {
  a: [
    { text: '技术类型', icon: IconInfo },
    { text: '手机出入', icon: IconPhone },
    { text: 'NFC 出入', icon: IconCard },
    { text: '人脸识别出入', icon: IconUser },
    { text: '出入标签', icon: IconKey },
    { text: '出入记录存储', icon: IconDownload },
    { text: '电源输入', icon: IconPlug },
    { text: '服务器通信', icon: IconTopology },
    { text: '主要使用场景', icon: IconBookmark },
    { text: '推荐使用环境', icon: IconThumbUp },
    { text: '外部系统对接', icon: IconShare },
  ],
  b: [
    { text: 'Bluetooth 5, 微波' },
    { text: '支持' },
    { text: '不支持' },
    { text: '不支持' },
    { text: '不支持' },
    { text: '进入记录存储' },
    { text: 'DC 12V, 24V（无极性）' },
    { text: 'Wi-Fi' },
    { text: '公寓、宿舍、医院等自动化空间' },
    { text: '车辆定位、资产追踪' },
    { text: '不支持' },
  ],
  c: [
    { text: 'Bluetooth 5, NFC' },
    { text: '支持' },
    { text: '支持' },
    { text: '不支持' },
    { text: '支持' },
    { text: '出入记录存储' },
    { text: 'PoE' },
    { text: 'PoE' },
    { text: '智能办公室、工作室、共享空间' },
    { text: '车辆定位、资产追踪' },
    { text: '提供 API' },
  ],
  d: [
    { text: 'Bluetooth 5, NFC, AI' },
    { text: '支持' },
    { text: '支持' },
    { text: '支持' },
    { text: '支持' },
    { text: '出入记录存储' },
    { text: '12V / 3A 适配器' },
    { text: 'PoE, Wi-Fi' },
    { text: '高端建筑、公用出入口、控制室' },
    { text: '工地、港口、物流中心、施工现场' },
    { text: '提供 API' },
  ],
  spec: [
    {},

    {
      image: accessAutoMain,
      link: '/access/auto',
      title: 'Access Auto',
      desc: '',
    },

    {
      image: accessLite1,
      link: '/access/lite',
      title: 'Access Lite',
      desc: '',
    },

    {
      image: accessProSchemeThumb,
      link: '/access/pro',
      title: 'Access Pro',
      desc: '',
    },
  ],
};
